import React from 'react';
import { StarIcon } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  author: string;
  date?: string;
}
export const TestimonialCard = ({
  quote,
  author,
  date = 'Verified Customer'
}: TestimonialCardProps) => {
  return <div className="bg-white rounded-lg shadow-lg mb-6 overflow-hidden" data-id="element-260">
      <div className="bg-[#00b67a] px-4 py-2 flex items-center" data-id="element-261">
        <div className="flex items-center" data-id="element-262">
          {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-white text-white" data-id="element-263" />)}
        </div>
      </div>
      <div className="p-6" data-id="element-264">
        <blockquote className="text-gray-800 text-lg mb-4" data-id="element-265">{quote}</blockquote>
        <div className="flex items-center justify-between text-sm" data-id="element-266">
          <p className="font-medium text-gray-700" data-id="element-267">{author}</p>
          <p className="text-gray-500" data-id="element-268">{date}</p>
        </div>
      </div>
      <div className="px-6 py-2 bg-gray-50 flex items-center justify-between" data-id="element-269">
        <div className="flex items-center" data-id="element-270">
          <svg className="w-4 h-4 text-[#00b67a] mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" data-id="element-271">
            <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" data-id="element-272" />
          </svg>
          <span className="text-[#00b67a] font-medium" data-id="element-273">Trustpilot</span>
        </div>
        <span className="text-xs text-gray-500" data-id="element-274">Posted on Trustpilot</span>
      </div>
    </div>;
};